export const __CONFIG_KEY__ = '__config__'
export const __ROOT_NODE__ = 'root'
export const __I18N_KEY__ = '__i18n__'

export const FALLBACK_DEFAULT_VERTICALS_WITH_ADDITIONAL_OPTIONS = ['cargo', 'express']
